import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import axios from 'axios';

import getMetaTagData from '../../src/common/services/getMetaTagData';
import TvTopMenu from '../../src/component/pc/tv/TopMenu';
import Theme from '../../src/component/pc/tv/Theme';
import Box from '../../src/component/pc/common/Box';
import Loading from '../../src/component/pc/common/Loading';

import { getSectionDataApiUrl } from '../../src/common/utils/tvUtil';
import { SECTION_LIST_PAGE_LIMIT } from '../../src/common/constants/number';
import { toFit } from '../../src/hooks/useToFit';

function Home({ defaultMetaTagData }) {
  const [sortHTxt, setSortHTxt] = useState('');
  const router = useRouter();
  const { pageSection: section, category = '', sort = 'top' } = router.query; // 기본값 'top' 설정

  const [pageSection, setPageSection] = useState(section);
  const [metaTagData, setMetaTagData] = useState(defaultMetaTagData);
  const [pageQueryParams, setPageQueryParams] = useState({
    section,
    category,
    sort: sort || 'top', // 기본값 'top'
    offset: 0,
    limit: SECTION_LIST_PAGE_LIMIT,
  });
  const [sectionDataList, setSectionDataList] = useState([]);
  const [sectionDataIsLoading, setSectionDataIsLoading] = useState(false);

  function sortCodeTxt(code) {
    let result;
    try {
      if (code === 'new') {
        result = '최신';
      } else if (code === 'top') {
        result = '인기';
      } else if (code === 'abc') {
        result = '가나다';
      } else if (code === 'theme') {
        result = '추천';
      } else if (code === 'all') {
        result = '전체';
      } else if (code === 'N') {
        result = '방영 예정';
      } else if (code === 'Y') {
        result = '방영 중';
      } else {
        result = '';
      }
    } catch (error) {
      result = '';
    }
    return result;
  }

  function onPageQueryParamsChanged({
    sectinoCode = '',
    categoryCode = '',
    sortCode = '',
  }) {
    setSortHTxt(sortCodeTxt(sortCode));
    pageQueryParams.section = sectinoCode;
    pageQueryParams.category = categoryCode;
    pageQueryParams.sort = sortCode;
    pageQueryParams.offset = 0;

    setPageQueryParams({ ...pageQueryParams });
    setPageSection(sectinoCode);
  }

  useEffect(() => {
    if (!router.query.sort) {
      router.replace({
        pathname: router.pathname,
        query: { ...router.query, sort: 'top' },
      });
    }
  }, [router.query]);

  useEffect(() => {
    window.document.addEventListener('scroll', toFit(doNextPage, {}));

    function doNextPage() {
      if (
        window.innerHeight + Math.ceil(window.pageYOffset) >=
        document.body.offsetHeight
      ) {
        setPageQueryParams((prev) => {
          const nextOffset = prev.offset + prev.limit;
          let sectionDataListLength;
          setSectionDataList((sPrev) => {
            sectionDataListLength = sPrev.length;
            return sPrev;
          });

          if (sectionDataListLength === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    const sectionDataApiUrl = getSectionDataApiUrl(
      pageQueryParams.offset,
      pageQueryParams.sort,
      pageQueryParams.section,
      pageQueryParams.category
    );
    const config = {
      method: 'get',
      url: sectionDataApiUrl.href,
      timeout: 3000,
    };

    setSectionDataIsLoading(true);

    axios(config)
      .then(function (response) {
        const addList = [];
        let clickParamsCategory = pageQueryParams.category;
        if (clickParamsCategory === null || clickParamsCategory === '') {
          clickParamsCategory = 'total';
        }
        const clickParamsSort = pageQueryParams.sort;
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          const item = {
            type: 'poster',
            img: element.pgm_img_url,
            info: { title: element.pgm_nm },
            label: [],
            link: element.link_url,
            isNew: element.new_yn === 'Y',
            contents: element.contents,
            data: { pgm_nm: element.pgm_nm },
            isfree: element.free_part_yn,
            link_new_yn: element.link_new_yn,
            clickParams:
              'div=tv_' + clickParamsCategory + '_' + clickParamsSort,
          };
          addList.push(item);
        }

        const currentOffset =
          Number.parseInt(sectionDataApiUrl.searchParams.get('offset')) || 0;

        if (currentOffset === 0) {
          if (addList.length > 0) {
            setSectionDataList(addList);
          } else {
            setSectionDataList([]);
          }
        } else {
          setSectionDataList((prev) => [...prev, ...addList]);
        }
      })
      .catch(function (error) {
        // Handle error
      })
      .finally(() => {
        setSectionDataIsLoading(false);
      });
  }, [pageQueryParams]);

  useEffect(() => {
    const curentaTagData = getMetaTagData(router.asPath, pageSection, category);
    setMetaTagData(curentaTagData);
  }, [pageSection]);

  if (pageQueryParams.sort === 'theme') {
    return (
      <div className="contents">
        <Head>
          <link
            key="css_pc_url"
            rel="stylesheet"
            href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
          />
          <meta
            key="viewport"
            name="viewport"
            content="width=device-width, initial-scale=1"
          />
          <script
            key="gnb_js_url"
            type="text/javascript"
            src={process.env.NEXT_PUBLIC_GNB_JS_URL}
          />
          <meta name="description" content={metaTagData.shareDescription} />
          <meta name="keywords" content={metaTagData.keywords} />
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role="main" id="container" className="tv_listcontents_wrap">
          <TvTopMenu
            sectionCode={section}
            categoryCode={category}
            sortCode={sort}
            onChange={onPageQueryParamsChanged}
          />
          <h3 className="hide">{sortHTxt}</h3>
          <Theme />
        </div>
      </div>
    );
  } else {
    return (
      <div className="contents">
        <Head>
          <link
            key="css_pc_url"
            rel="stylesheet"
            href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
          />
          <meta
            key="viewport"
            name="viewport"
            content="width=device-width, initial-scale=1"
          />
          <script
            key="gnb_js_url"
            type="text/javascript"
            src={process.env.NEXT_PUBLIC_GNB_JS_URL}
          />
          <meta name="description" content={metaTagData.shareDescription} />
          <meta name="keywords" content={metaTagData.keywords} />
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role="main" id="container" className="tv_listcontents_wrap">
          <TvTopMenu
            sectionCode={section}
            categoryCode={category}
            sortCode={sort}
            onChange={onPageQueryParamsChanged}
          />
          <div className="contents_area_tvlist">
            <div className="tv_list_w">
              <h3 className="hide">{sortHTxt}</h3>
              <ul className="tv_list_inner">
                {sectionDataList.map((item, index) => (
                  <li key={index} className="tv_list_cont">
                    <Box view {...item} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {sectionDataIsLoading && <Loading />}
        </div>
      </div>
    );
  }
}

export async function getServerSideProps(ctx) {
  const { pageSection, pageCategory } = ctx.query;
  const defaultMetaTagData = getMetaTagData(
    ctx.req.url,
    pageSection,
    pageCategory
  );

  const tvSectionTopList = await getTvSectionTopList(pageSection, pageCategory);

  if (
    Array.isArray(tvSectionTopList?.data) &&
    tvSectionTopList.data.length > 0
  ) {
    const topProgramTitleList = tvSectionTopList.data.map(
      (item) => item.pgm_nm
    );
    if (defaultMetaTagData.keywords) {
      defaultMetaTagData.keywords += ',' + topProgramTitleList.toString();
    } else {
      defaultMetaTagData.keywords = topProgramTitleList.toString();
    }
  }

  return { props: { defaultMetaTagData } };
}

async function getTvSectionTopList(sectionCode, categoryCode) {
  const sectionDataApiUrl = getSectionDataApiUrl(
    0,
    'top',
    sectionCode,
    categoryCode,
    20
  );
  const config = {
    method: 'get',
    url: sectionDataApiUrl.href,
    timeout: 3000,
  };

  return axios(config).catch(function (error) {
    // Handle error
  });
}

export default Home;
